module.exports = __webpack_public_path__ + "img/story-banner-bg.32a8305a.jpg";